(function ($) {
    let searchDelayTimeout = null;

    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */


    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */

    $.fn.dataTable.Api.register('setSearchDebounce()', function (milliseconds) {
        const table = this;
        $('div.dataTables_filter input', table.context[0].nTableWrapper).off('keyup.DT search.DT input.DT paste.DT cut.DT')
            .on('keyup.DT search.DT input.DT paste.DT cut.DT', function () {
                const search = $('div.dataTables_filter input', table.context[0].nTableWrapper).val();
                clearTimeout(searchDelayTimeout);
                searchDelayTimeout = setTimeout(function () {
                    table.search(search).draw();
                }, milliseconds);
            });
        return this;
    });

}(jQuery));